import StackBarPlot from './plot';
import StackBarChart from './chart';
import StackBarSpec from './chartSpec';

export default StackBarChart;
export { StackBarPlot, StackBarSpec };
